import React, { useEffect, useState, createElement } from 'react';
import { X, Download, FileDown, ExternalLink } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LloydPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Pixel base + init + PageView handled globally in App.tsx — removed here
    // to avoid double-counting.
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/g1yujvw3vj.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(playerScript);
    document.head.appendChild(embedScript);
    return () => {
      if (document.head.contains(playerScript)) {
        document.head.removeChild(playerScript);
      }
      if (document.head.contains(embedScript)) {
        document.head.removeChild(embedScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-3326" data-mp="2htnnz5foq39t">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3327" data-mp="fw3rp9a59khm">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3328" data-mp="fvllbjtrppvz" />
      </noscript>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-10 md:py-16" data-id="element-3329" data-mp="64zby7cn9vlq">
        {/* Header Section */}
        <div className="text-center mb-6 md:mb-10 space-y-5" data-id="element-3330" data-mp="b4bzyvf958pw">
          {/* Title */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black leading-tight tracking-tight" data-id="element-3331" data-mp="3scqtsaug3yoe">
            Crea tu producto digital en minutos,{' '}
            <span className="neon-sweep" data-id="element-3332" data-mp="14l2qlzb4fm4">sin salir de tu pantalla</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-gray-100 max-w-4xl mx-auto leading-relaxed font-serif-elegant font-light" data-id="element-3333" data-mp="3obnblhoxdqk0">
            Mira cómo construyo un producto digital desde cero, en tiempo real,
            con HeyLloyd como mi asistente sobre cualquier aplicación. Sin
            cursos eternos, sin configuraciones complicadas: solo ves, copias y
            lanzas.
          </p>
        </div>

        {/* Video Section */}
        <div className="mb-8 md:mb-12" data-id="element-3334" data-mp="1rq76214m4g6s">
          <div className="relative max-w-4xl mx-auto" data-id="element-3335" data-mp="1rnb4m2tk39dl">
            {/* Green glow effect */}
            <div className="absolute -inset-2 bg-gradient-to-r from-green-500 via-green-400 to-green-500 opacity-75 blur-2xl" data-id="element-3336" data-mp="25inbt9owesbe"></div>

            <div className="relative aspect-video bg-gray-900 border border-green-500/50 overflow-hidden shadow-2xl" data-id="element-3337" data-mp="2fegn6pqvsfrl">
              <style data-id="element-3338" data-mp="2agf444tgggg4">
                {`
                  wistia-player[media-id='g1yujvw3vj']:not(:defined) { 
                    background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/g1yujvw3vj/swatch'); 
                    display: block; 
                    filter: blur(5px); 
                    padding-top: 56.25%; 
                  }
                `}
              </style>
              <wistia-player media-id="g1yujvw3vj" aspect="1.7777777777777777" data-id="element-3339" data-mp="q13l7768r3tn"></wistia-player>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-2xl mx-auto text-center space-y-5 mb-10 md:mb-14" data-id="element-3340" data-mp="wfiwolrsyc9n">
          <a href="/checkout-lloyd" className="group relative block w-full bg-gradient-to-b from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#06b6d4]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-3341" data-mp="10hm9peu4dox1">
            <span className="flex items-center justify-center gap-3" data-id="element-3342" data-mp="crjnhfcvzd6c">
              <Download className="w-6 h-6" data-id="element-3343" data-mp="cpp445h9jt4d" />
              Descarga A Mi LLOYD Personalizado HOY
            </span>
          </a>

          {/* Urgency Text */}
          <p className="text-yellow-400 font-semibold text-sm md:text-base" data-id="element-3344" data-mp="mjflkqez33ak">
            Oferta por tiempo limitado
          </p>

          {/* Support Text */}
          <p className="text-base md:text-lg text-gray-100 max-w-4xl mx-auto leading-relaxed font-serif-elegant font-light" data-id="element-3345" data-mp="3q6fwkf60h2eh">
            Convierte tu pantalla en un estudio de creación: idea, diseño,
            contenido y lanzamiento, todo guiado por mi Lloyd personalizado para
            que puedas replicarlo paso a paso.
          </p>

          {/* Demo Resources */}
          <div className="pt-4 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3346" data-mp="34nntgy5fxuwn">
            <a href="https://drive.google.com/file/d/1RkyQQDL3XROBUWwY-NAVJiQpm7NQ2zdj/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white font-medium text-sm md:text-base rounded-lg py-3 px-6 border border-gray-700 hover:border-green-500/50 transition-all duration-300" data-id="element-3347" data-mp="34ne339ghhlqf">
              <FileDown className="w-5 h-5" data-id="element-3348" data-mp="2l0pslog5p47d" />
              Descargar Producto Demo
            </a>
            <a href="https://project-wise-swamp-350.magicpatterns.app" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white font-medium text-sm md:text-base rounded-lg py-3 px-6 border border-gray-700 hover:border-green-500/50 transition-all duration-300" data-id="element-3349" data-mp="2gx1l15riy8m4">
              <ExternalLink className="w-5 h-5" data-id="element-3350" data-mp="26av6ce0r018f" />
              Ver Website del Demo
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-800 mt-14" data-id="element-3351" data-mp="1xdcjd43jnctw">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-3352" data-mp="2l1m03rlwhae6">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-3353" data-mp="2pzx7zwsmxatr">
            <p data-id="element-3354" data-mp="2bcu9pnwhmy5d">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-3355" data-mp="163q27lm8gkp8">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-3356" data-mp="nfcsl67veuoq">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-3357" data-mp="1ttu8k0qt2yjx">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-3358" data-mp="2itgs3afws2dw">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-3359" data-mp="2roenco6j3r8e">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-800" data-id="element-3360" data-mp="31lj9io0djmp7">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-3361" data-mp="36l5op2zrjd0n">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-3362" data-mp="3am7e6s3voapf">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-3363" data-mp="1c860ilhbhahr">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-3364" data-mp="18q8jv6mzed54">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-3365" data-mp="13y8g133sj039">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-3366" data-mp="uxsbrrf83oxc">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-3367" data-mp="uzd9fpwu3nzf">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-3368" data-mp="1imbocj5b2nv8">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3369" data-mp="1do0faamu4he2">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-3370" data-mp="28v8ovjl1yp6">
              <X className="w-6 h-6" data-id="element-3371" data-mp="27amo5l6k340" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-3372" data-mp="3te53bbsdbg67">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3373" data-mp="b0xexlq6io8g">
              <p data-id="element-3374" data-mp="67unpk8vjqvf">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3375" data-mp="fxe5snorjgp8">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-3376" data-mp="txfhky6kg8jh">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3377" data-mp="2ro9sbmj64ya6">
                2. Uso del Servicio
              </h3>
              <p data-id="element-3378" data-mp="2hl4eanfkqeuu">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3379" data-mp="27s5ox3c96ka6">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-3380" data-mp="1xwc4yyw7foid">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3381" data-mp="1ttyzmblddsm4">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-3382" data-mp="3j9yf0afl0ea7">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3383" data-mp="3hshux6mauyop">
                5. Modificaciones
              </h3>
              <p data-id="element-3384" data-mp="3csdf7it7u7zj">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3385" data-mp="9e98kgadf44z">Contacto</h3>
              <p data-id="element-3386" data-mp="4e52lk739rt0">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-3387" data-mp="3vqg848ovwp2m">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-3388" data-mp="nbxy41fduzgd">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3389" data-mp="up6v8g4v3xcl">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-3390" data-mp="14l0f6kkwut4e">
              <X className="w-6 h-6" data-id="element-3391" data-mp="19lxwyw20dl5d" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-3392" data-mp="1dmzxrhbkq59g">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3393" data-mp="1ijqca07qcssr">
              <p data-id="element-3394" data-mp="1ndce0xccvc9s">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3395" data-mp="1x8e53yq6yof0">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-3396" data-mp="2z05or0vt9x2y">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3397" data-mp="2u12p5vyloj2d">
                <li data-id="element-3398" data-mp="37t8z30b5tttd">Nombre y dirección de correo electrónico</li>
                <li data-id="element-3399" data-mp="33rdunmxxn0bd">Información de registro del evento</li>
                <li data-id="element-3400" data-mp="33rxdr6zbjuqz">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3401" data-mp="2g2m9vgmo9k8m">
                2. Uso de la Información
              </h3>
              <p data-id="element-3402" data-mp="2b4kqsvp8xkx5">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3403" data-mp="2p30zutakznig">
                <li data-id="element-3404" data-mp="2p052b62nb0uj">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-3405" data-mp="4br0ljha1z5m">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-3406" data-mp="4ed67dkly4l7">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-3407" data-mp="3vhjtbkmcov8o">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3408" data-mp="7tog2uzvmqgo">
                3. Compartir Información
              </h3>
              <p data-id="element-3409" data-mp="bwkt866ndud8">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3410" data-mp="qlqq3ni0j8hy">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-3411" data-mp="vj925mrbu3u6">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3412" data-mp="19jtm4m8za5p9">
                5. Tus Derechos
              </h3>
              <p data-id="element-3413" data-mp="1eas03f6hurpc">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-3414" data-mp="1j75wfwovyzpw">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3415" data-mp="1e9xd3ss04pn2">6. Cookies</h3>
              <p data-id="element-3416" data-mp="1a67qv9ysuk57">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3417" data-mp="10f3cabd1d1aw">Contacto</h3>
              <p data-id="element-3418" data-mp="vgtd7po6xgk0">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-3419" data-mp="qj9tia8q4bko">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}